// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","637":"component---src-templates-blog-template-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"bcc4bf239a80aa32f00d","637":"4fede1b4b874bea34709","678":"35cade8a7527e541bbc1","883":"090453de2e3139da5d4a"}[chunkId] + ".js";
};